const PREFIX = 'CHAT'

export const CHAT_START = `${PREFIX}_START`
export const CHAT_START_ERROR = `${PREFIX}_START_ERROR`
export const CHAT_START_STATUS = `${PREFIX}_START_STATUS`

export const CHAT_GET = `${PREFIX}_GET`
export const CHAT_GET_ERROR = `${PREFIX}_GET_ERROR`
export const CHAT_GET_STATUS = `${PREFIX}_GET_STATUS`

export const CHAT_MESSAGES_FETCH = `${PREFIX}_MESSAGES_FETCH `
export const CHAT_MESSAGES_FETCH_ERROR = `${PREFIX}_MESSAGES_FETCH_ERROR`
export const CHAT_MESSAGES_FETCH_STATUS = `${PREFIX}_MESSAGES_FETCH_STATUS`
export const CHAT_MESSAGES_FETCH_MORE_STATUS = `${PREFIX}_FETCH_MORE_STATUS`

export const CHAT_STORE_MESSAGE = `${PREFIX}_STORE_MESSAGE`
export const CHAT_STORE_MESSAGE_ERROR = `${PREFIX}_STORE_MESSAGE_ERROR`
export const CHAT_STORE_MESSAGE_STATUS = `${PREFIX}_STORE_MESSAGE_STATUS`

export const CHAT_EDIT_MESSAGE = `${PREFIX}_EDIT_MESSAGE`
export const CHAT_EDIT_MESSAGE_ERROR = `${PREFIX}_EDIT_MESSAGE_ERROR`
export const CHAT_EDIT_MESSAGE_STATUS = `${PREFIX}_EDIT_MESSAGE_STATUS`

export const CHAT_DELETE_MESSAGE = `${PREFIX}_DELETE_MESSAGE`
export const CHAT_DELETE_MESSAGE_ERROR = `${PREFIX}_DELETE_MESSAGE_ERROR`
export const CHAT_DELETE_MESSAGE_STATUS = `${PREFIX}_DELETE_MESSAGE_STATUS`

export const CHAT_STORE_RECIPIENT_MESSAGE = `${PREFIX}_STORE_RECIPIENT_MESSAGE`
export const CHAT_EDIT_RECIPIENT_MESSAGE = `${PREFIX}_EDIT_RECIPIENT_MESSAGE`
export const CHAT_DELETE_RECIPIENT_MESSAGE = `${PREFIX}_DELETE_RECIPIENT_MESSAGE`

export const CHAT_VIOLATIONS_GET = `${PREFIX}_VIOLATIONS_GET`
export const CHAT_VIOLATIONS_GET_ERROR = `${PREFIX}_VIOLATIONS_GET_ERROR`

// export const CHAT_REPORT = `${PREFIX}_REPORT`
export const CHAT_REPORT_ERROR = `${PREFIX}_REPORT_ERROR`
export const CHAT_REPORT_STATUS = `${PREFIX}_REPORT_STATUS`

export const CHAT_FETCH = `${PREFIX}_CHATS`
export const CHAT_FETCH_ERROR = `${PREFIX}_FETCH_ERROR`
export const CHAT_FETCH_STATUS = `${PREFIX}_FETCH_STATUS`

export const CHAT_DELETE = `${PREFIX}_DELETE`
export const CHAT_DELETE_ERROR = `${PREFIX}_DELETE_ERROR`
export const CHAT_DELETE_STATUS = `${PREFIX}_DELETE_STATUS`

export const CHAT_MESSAGE_READ = `${PREFIX}_MESSAGE_READ`
